

























































































































import {Component, Prop, Vue} from 'vue-property-decorator'
import spacetime, {Spacetime} from "spacetime";
import {jobDescriptionOptions} from "@/util/jobDescriptionOptions";
import StaticLabel from "@/components/util/StaticLabel.vue";

type UserBasicDetails = {
    firstName: string;
    lastName: string;
    jobDescription?: string;
    countryName?: string;
    city?: string;
    postCode?: string;
    address?: string;
    mobileNumber?: string;
    dob?: string;
}

@Component({
    components: { StaticLabel }
})
export default class BasicAccountDetails extends Vue {

    @Prop()
    userBasicDetailsProp!: UserBasicDetails;

    private userBasicDetails: UserBasicDetails = { ...this.userBasicDetailsProp };
    private jobOptions = jobDescriptionOptions;

    private isEditing: boolean = false;
    private loading: boolean = false;
    private otherJobDescription: string | null = null;

    private dob: Spacetime | null = this.userBasicDetails.dob ? spacetime(this.userBasicDetails.dob) : null;

    private get formattedDob(): string {
        if (this.userBasicDetails.dob) {
            return spacetime(this.userBasicDetails.dob).format('numeric-uk').toString();
        }
        return 'N/A';
    }

    private cancelEditing() {
        this.isEditing = false;
        this.userBasicDetails = { ...this.userBasicDetailsProp };
    }
}
